<section class="close-window">
    <img src="/assets/imgs/apply-success.png" class="mx-auto" />
    <h3 *ngIf="pageMode === 'redirect'">You have successfully authenticated. Redirecting...</h3>
    <h3 *ngIf="pageMode === 'close'">You have successfully authenticated. You may now close this window.</h3>
</section>
